import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'

interface Props {
  id: string
  onSuccess?: () => void
  children?: () => ReactElement
}

const DeleteAiTestConfigTaskRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/testconfigtasks/${id}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='delete'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default DeleteAiTestConfigTaskRequest
